// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filter-detail {\n  width: 100px;\n  height: 40px;\n  background: #35BA83;\n  border-radius: 4px 4px 4px 4px;\n  font-size: 14px;\n  font-family: Microsoft YaHei, Microsoft YaHei;\n  font-weight: 400;\n  color: #FFFFFF;\n  cursor: pointer;\n  margin-left: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
